import { fallbackPosts } from "../fallback/contentFallbacks";
import { mapWordPressPost } from "../mappers/wordpressMappers";
import { createServiceResult } from "./serviceResult";
import { fetchPostBySlug, fetchPosts } from "../wordpress/wordpressApi";

function filterPosts(posts, options = {}) {
  return posts.filter((post) => {
    const matchesSearch = options.search
      ? `${post.title} ${post.excerpt}`
          .toLowerCase()
          .includes(options.search.toLowerCase())
      : true;
    const matchesCategory = options.category
      ? post.category === options.category
      : true;
    const matchesTag = options.tag ? post.tags.includes(options.tag) : true;

    return matchesSearch && matchesCategory && matchesTag;
  });
}

export async function getBlogPosts(options = {}) {
  try {
    const response = await fetchPosts(options);
    const items = filterPosts(response.data.map(mapWordPressPost), options);

    return createServiceResult({
      data: items,
      source: "api",
    });
  } catch (error) {
    const fallbackItems = filterPosts(fallbackPosts, options).slice(
      0,
      options.limit || fallbackPosts.length
    );

    return createServiceResult({
      data: fallbackItems,
      source: "fallback",
      error,
      usedFallback: true,
    });
  }
}

export async function getBlogPostBySlug(slug, options = {}) {
  try {
    const response = await fetchPostBySlug(slug, options);
    const post = response.data.map(mapWordPressPost)[0] || null;

    return createServiceResult({
      data: post,
      source: "api",
    });
  } catch (error) {
    const fallbackItem = fallbackPosts.find((item) => item.slug === slug) || null;

    return createServiceResult({
      data: fallbackItem,
      source: "fallback",
      error,
      usedFallback: true,
    });
  }
}
